// ==================================================
// tile.js関連
// ==================================================

var myTile = {};

/**
 * ブレークポイント
 * @type {number}
 */
myTile.breakpoints = 767;

/**
 * on('resize')用タイマー
 */
myTile.timer = false;

/**
 * ウィンドウ幅を取得
 * @return {number} ウィンドウ幅
 */
myTile.getWindowWidth = function () {
  return window.innerWidth || $(window).width();
};

/**
 * ウィンドウ幅とブレークポイントを比較
 * @return {boolean}
 */
myTile.compare = function () {
  return (this.getWindowWidth() > this.breakpoints) ?
    true :
    false;
};

/**
 * 物件の住所と土地面積の高さを揃える
 * PC時は4つごと、SP時は2つごと。
 */
function tilejs_to_articles() {
  var $targets = [$('.p-index_addr'), $('.p-index_breadth')];
  for (var i = 0; i < $targets.length; i++) {
    myTile.compare() ? $targets[i].tile(4) : $targets[i].tile(2);
  }
}

/**
 * 不動産トップ用tile.js
 */
myTile.page_home = function () {
  var $targets = [$('.pickupList_head'), $('.pickupList_info'), $('.pickupList_txt')];
  for (var i = 0; i < $targets.length; i++) {
    $targets[i].tile();
  }
};

/**
 * ご売却の流れ、ご購入の流れページ用tile.js
 */
myTile.page_flow = function () {
  var $target = $('.chart_txt');
  this.compare() ? $target.tile() : $target.css('height', 'auto');

};

/**
 * 不動産コンサルティングページ用tile.js
 */
myTile.page_consulting = function () {
  var $target = $('.aboutList');
  this.compare() ? $target.tile(2) : $target.css('height', 'auto');
};

/**
 * 不動産コンサルティングページ用tile.js
 */
myTile.page_search = function () {
  var $target = $('.selectArea_content .c-inputCheck');
  if (this.compare()) $target.css('height', 'auto');
};

/**
 * リースバックページ用tile.js
 */
myTile.page_case5 = function () {
  var $target = $('.aboutList');
  this.compare() ? $target.tile(2) : $target.css('height', 'auto');
};

/**
 * ページを判定して、そのページ用のtile.jsを実行する
 */
myTile.branch_off = function () {
  var $main = $('main');
  if ($main.hasClass('home')) {
    this.page_home();
  } else if ($main.hasClass('sell') || $main.hasClass('buy')) {
    this.page_flow();
  } else if ($main.hasClass('consulting')) {
    this.page_consulting();
  } else if ($main.hasClass('search')) {
    this.page_search();
  }
  if ($main.hasClass('case5')) {
    this.page_case5();
  }
};


// ----------------------------------------
//                Ready
// ----------------------------------------
$(function () {
  myTile.branch_off();
});

// ----------------------------------------
//                Resize
// ----------------------------------------
$(window).on('resize', function () {
  if (myTile.timer) {
    clearTimeout(myTile.timer);
  }
  myTile.timer = setTimeout(function () {
    myTile.branch_off();
    tilejs_to_articles();
  }, 30);
});

// ----------------------------------------
//                Click
// ----------------------------------------
$('body').on(
  'click',
  '.selectArea_head',
  function () {
    if (!myTile.compare()) {
      var $trigger = $(this);
      var $content = $trigger.next();
      $trigger.toggleClass('is-open')
      $content.stop().slideToggle();
      if ($('.selectArea_head').hasClass('is-open')) {
        $('.selectArea_head.is-open + .selectArea_content .c-inputCheck').tile(2);
      }
    }
  }
);
